module.exports = __webpack_public_path__ + "img/phil-care-loading-logo.b2a6c31b.gif";